import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getDocumentTypeDisplayLabel, isPeriodClosedError } from "src/utils/documentsI18n";
import { formatRut, formatMoneyWithCurrency, formatSafeTableDate } from "../../utils/formatter";
import { documentsDic, DOCUMENT_STATE } from "../../utils/dataDictionary";
import { eerrMacroCategories } from "../../utils/eerrCategories";
import {
  Icon,
  Dropdown,
  Checkbox,
  Progress,
  Popup,
  Button,
  Input,
  Label,
  Form,
} from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { importOpenSidebar } from "../../redux/actions/openSidebar";
import { GenerateMatch, GenerateMultipleUnMatch } from "../../graphql/conciliacion";
import { CreateObligation } from "../../graphql/obligations";
import { parseObligation, ModalForm, checkComplete } from "./functions";
import { importAlertState } from "../../redux/actions/alert";
import { importNewModal } from "../../redux/actions/newModal";
import { SettleDocumentAndPoint } from "../../graphql/taxDocument";
import { SettleDocument } from "../../graphql/documents";
import moment from "moment";
import "./nuevaTablaDocumentos.scss";
import { Plans } from "src/utils/plans";
import { DocumentType } from "src/utils/enum";
import { getObligationDisplayAmount } from "src/components/tarjetasCredito/tcObligationHelpers";
import { showAccounting } from "src/utils/accounting";
import { setUpdateDocuments } from "src/redux/actions/documentostributarios";
import ModalSettleConflictNominas from "./ModalSettleConflictNomina";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

import FeatherIcon from "feather-icons-react";
import { BsLightningChargeFill } from "react-icons/bs";
import CustomModal from "../configuracion/components/customModal";
import TableContent from "./modalDetalleDocumento/components/TableContent";
import CircleIndicator from "./CircleIndicator";
import { PartialPayoffModal } from "../modal/flow/partialPayoff";
import VincularDocumentoModal from "../general/js/forms/reconcile/VincularDocumentoModal";
import CommentBadge from "../transactions(new)/TransactionRowComponents/CommentBadge";
import AccountingBadge from "../transactions(new)/TransactionRowComponents/AccountingBadge";
import { summarizeDocumentMatchAccounting } from "../../utils/documentMatchAccounting";
import { getDescription } from "../general/js/forms/reconcile/components/matchRowHelpers";
import { openDocumentDetail } from "../../utils/documentModal";
import { useBlockedFeatures } from "src/hooks/useBlockedFeatures";
import { getReconciliationPercent, progressTierClassName } from "../../utils/reconciliationProgress";
import {
  getDinForm,
  getDinIssuedDate,
  getDinNetAmount,
  getDinOriginalAmount,
  getDinPaymentDate,
  getDinTaxAmount,
  isDinPath,
} from "./dinRowHelpers";
import {
  inMatchPairsFromDocument,
  useStatementUnmatchGuard,
} from "../general/js/forms/reconcile/hooks/useStatementUnmatchGuard";
import StatementLinkedUnmatchModal from "../general/js/forms/reconcile/components/StatementLinkedUnmatchModal";

/** Renders a formatted date or an em dash placeholder (never "Invalid date"). */
const TableDateCell = ({ value, format = "DD/MM/YYYY" }) => {
  const s = formatSafeTableDate(value, format);
  if (s === null) {
    return <span className="scfo-table-date-placeholder">—</span>;
  }
  return <>{s}</>;
};

const HONORARIO_DOCUMENT_CODES = [0, 1, '0', '1'];

const resolveTableMontoAmount = (data) => {
  if (data?.documentType === DocumentType.OBLIGATION) {
    return getObligationDisplayAmount(data);
  }
  const meta = data?.meta || {};
  if (HONORARIO_DOCUMENT_CODES.includes(meta.documentCode)) {
    const netAmount = meta.netAmount;
    if (netAmount !== undefined && netAmount !== null && netAmount !== '') {
      return netAmount;
    }
  }
  return meta.originalAmount ?? data?.amount ?? 0;
};

const TablaFila = ({
  data,
  index,
  isAllSelected,
  setIsAllSelected,
  isSideBarOpen,
  selectedDocs,
  setSelectedDocs,
  isChecked,
  selected,
  small = false,
  setEditTitle,
  plan,
  eerrAreas,
  selectedAmountDocs,
  setSelectedAmountDocs,
  tableRef,
  documentsLength,
  selectedDocumentId,
  onOpenReconcile,
  progressColWidthPx = 176,
  gridTemplateColumns,
  isReconcileOpen = false // When reconcile panel is open, show compact version
}) => {
  const { t } = useTranslation("documents");
  const dispatch = useDispatch();
  const { roles } = useSelector((state) => state.auth);
  const { selectedCompany } = useSelector((state) => state.companyList);
  const {
    summary: statementUnmatchSummary,
    setSummary: setStatementUnmatchSummary,
    findBlockedSummary,
    fetchSummaryForPair,
  } = useStatementUnmatchGuard(selectedCompany?.id || data?.companyId);
  const matchAccounting = useMemo(
    () => summarizeDocumentMatchAccounting(data),
    [data],
  );
  const [openType, setOpenType] = useState("close");
  const [showModal, setShowModal] = useState(false)
  const { openSidebar } = useSelector((state) => state.openSidebar);
  const [showConflict, setShowConflict] = useState(data?.meta?.hasSettleConflict)
  const [total, setTotal] = useState(0)
  const [openCostCenterModal, setOpenCostCenterModal] = useState(false);
  const [openCustomModal, setOpenCustomModal] = useState(false)
  const [showPartialPayoffModal, setShowPartialPayoffModal] = useState(false)
  const [partialPayoffAmount, setPartialPayoffAmount] = useState("")
  const [partialPayoffDate, setPartialPayoffDate] = useState("")
  const [isRowHovered, setIsRowHovered] = useState(false);
  const { isConciliacionBlocked, isCrearObligacionBlocked, isAbonarBlocked } = useBlockedFeatures();

  const history = useHistory();
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const onClickNotesLabel = useCallback(() => {
    // Open inner right component (reconcile sidebar) on comments tab via URL
    // This matches the pattern used in openReconcileSideBar
    const currentScrollY = window.scrollY || window.pageYOffset;
    
    // Update URL with documentId and set isComment to true to open comments tab
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('documentId', data._id);
    newSearchParams.set('isComment', 'true');
    newSearchParams.delete('isDocumentDetail');
    const currentSearch = (location.search || "").replace(/^\?/, "");
    const nextSearch = newSearchParams.toString();
    // Avoid re-pushing the exact same URL (can create render loops for deep-links).
    if (nextSearch !== currentSearch) {
      history.push({
        pathname: location.pathname,
        search: nextSearch
      });
    }

    // Use onOpenReconcile callback if provided (for inner sidebar)
    if (onOpenReconcile) {
      onOpenReconcile(data);
    }

    // Restore scroll position after navigation
    requestAnimationFrame(() => {
      window.scrollTo(0, currentScrollY);
    });
  }, [dispatch, data, history, location, onOpenReconcile]);

  const onClickAccountingLabel = useCallback((e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const currentScrollY = window.scrollY || window.pageYOffset;

    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('documentId', data._id);
    newSearchParams.set('isAccounting', 'true');
    newSearchParams.delete('isComment');
    newSearchParams.delete('isDocumentDetail');
    const currentSearch = (location.search || "").replace(/^\?/, "");
    const nextSearch = newSearchParams.toString();
    if (nextSearch !== currentSearch) {
      history.push({
        pathname: location.pathname,
        search: nextSearch
      });
    }

    if (onOpenReconcile) {
      onOpenReconcile(data);
    }

    requestAnimationFrame(() => {
      window.scrollTo(0, currentScrollY);
    });
  }, [data, history, location, onOpenReconcile]);

  // First useEffect - handle document selection
  useEffect(() => {
    const documentId = searchParams.get("id");
    const isGlobalSearch = searchParams.get("isGlobalSearch");
    
    const shouldProcessDocument = documentId && data?._id && documentId === data?._id;
    const shouldProcessGlobalSearch = !isGlobalSearch || (index === 0 && documentsLength === 1);
    
    if (shouldProcessDocument && shouldProcessGlobalSearch) {
      const isObligation = data?.documentType === DocumentType.OBLIGATION;

      if (isObligation) {
        setEditTitle(t("row.detailObligation"));
      } else if (isDinPath(location.pathname) || data?.meta?.documentCode === 914) {
        setEditTitle(t("row.detailDin"));
      } else {
        setEditTitle(t("row.detailFees"));
      }

      const params = { 
        show: true, 
        editData: data,
        ...(isObligation ? { editObligation: true } : { editTaxDocument: true })
      };
    }
  }, [searchParams, data?._id, index, documentsLength])

  // Second useEffect - handle comment navigation
  useEffect(() => {
    const isComment = searchParams.get("isComment");
    const documentId = searchParams.get("id");
    const hasInnerPanelDocumentId = !!searchParams.get("documentId");
    
    const shouldNavigateToComments = isComment && documentId && data?._id && data?._id === documentId;
    
    // If `documentId` is already present, TablaDocumentos will open the inner panel from the URL.
    // Only run the legacy flow (push documentId/isComment) when documentId is missing.
    if (shouldNavigateToComments && !hasInnerPanelDocumentId) {
      onClickNotesLabel();
    }
  }, [searchParams, data?._id, onClickNotesLabel])

  const showTitle = index == 0 ? "visible" : "hidden";
  const isCreditRoute = location.pathname === "/cuotas_de_creditos";
  const isDinRoute = isDinPath(location.pathname);
  const isCredit = data?.documentType === DocumentType.CREDIT || data?.documentType === "CREDIT";

  const isReceived = data?.meta?.isReceived === true;
  const taxAmount = data?.meta?.taxAmount || 0;
  const amount = data?.amount || 0;
  const remaining = data?.meta?.remaining ?? 0;
  const isUncollectible = !!data?.meta?.isUncollectible;
  const interestAmount = isCredit
    ? (data?.meta?.interestCLP ?? data?.meta?.interest ?? 0)
    : 0;
  const stockAmount = isCredit
    ? (data?.meta?.stockCLP ?? data?.meta?.stock ?? 0)
    : 0;
  const progress = Math.abs(amount) - Math.abs(remaining);
  const reconciliationPct = getReconciliationPercent(amount, remaining);
  const color = isReceived ? "#FF6666" : "#33CC33";
  const isObligation = data?.documentType === "OBLIGATION";
  const isValid = data.meta?.isValid
  const isProtested = data.meta?.isProtested
  const top = 22;

  const dataModal = {
    id: data?._id,
    nominaStatus: data?.meta?.nominaStatus,
    documentType: data?.documentType,
    detail: data?.meta?.summary || data?.meta?.typeLabel,
    folio: data?.meta?.documentId || data?.meta?.number || '0',
    remaining: data?.meta?.remaining,
  }

  const { executeMutation: generateMatch } = GenerateMatch();
  const { executeMutation: createObligation } = CreateObligation();
  const { reexecuteMutation: settleDocumentAndPoint } =
    SettleDocumentAndPoint();
  const { executeMutation: unGenerateMultipleMatch } = GenerateMultipleUnMatch()
  const { executeMutation: settleDocumentMutation } = SettleDocument();

  const { show, editData } = isSideBarOpen;

  useEffect(() => {
    setShowConflict(Boolean(data?.meta?.hasSettleConflict))
  }, [data?.meta?.hasSettleConflict])

  const isCreditOrDebitNote = [
    56,
    61,
    111,
    112,
    "56",
    "61",
    "111",
    "112",
  ].includes(data.meta.documentCode);
  const isTaxDocument = ["TAX_DOCUMENT"].includes(data.documentType);

  const OpenPendingDocModal = () => {

    const showModal = {
      show: true,
      title: t('sii.pendingAcceptTitle'),
      confirmButtonIconRight: `chevron right`,
      size: 'tiny',
      onCancelText: t('sii.close'),
      hideAcceptButton: true
    }

    const children = (
      <div className="d-flex flex-column w-100" style={{ paddingBottom: '200px' }}>
        <span>{t('sii.pendingAcceptBody')}</span>
      </div>
    )


    showModal.children = children

    dispatch(importNewModal(showModal))
  }

  const docDetailTable = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    // Open DocumentDetailContainer modal via URL parameters
    const documentId = data._id || data.id;
    if (documentId) {
      openDocumentDetail(documentId, history, location);
    }
  };

  const acceptDocSidebar = (editData) => {
    dispatch(
      importOpenSidebar({ show: true, acceptDocSii: true, editData: [editData], options: { multiple: false } })
    )
  }


  const unSettleDocument = async (document) => {
    try {
      const inMatch = document.meta?.matchs?.inMatch || [];

      const input = inMatch.map((match) => ({
        endType: match.type,
        endId: match.id || match.settleId,
        originType: document.documentType,
        originId: document._id || document.id,
        companyId: document.companyId,
        amount: match.amount,
      }));

      dispatch(importNewModal({ show: false }));
      
      const { data, error } = await unGenerateMultipleMatch({ input });

      dispatch(setUpdateDocuments({ value: true }))

      return dispatch(importAlertState({
        content: t("alerts.balanceUpdated"),
        state: "success",
        duration: 4,
      }))

    } catch (err) {
      const errorMessage = err?.graphQLErrors?.[0]?.message || err?.message || t("alerts.balanceUpdateError");
      const isPeriodLocked = isPeriodClosedError(errorMessage);
      return dispatch(importAlertState({
        concept: isPeriodLocked ? t("common.periodClosed") : undefined,
        content: errorMessage,
        state: isPeriodLocked ? "warning" : "error",
        duration: isPeriodLocked ? 6 : 4,
      }))

    }
  };

  const settleDocument = async (document, paymentDate) => {
    try {
      setOpenType('close');
      
      dispatch(
        importAlertState({
          content: `Saldando documento...`,
          state: "loading",
          duration: 100,
        })
      );

      const input = {
        documentId: document._id,
        paymentDate: paymentDate ? new Date(paymentDate) : new Date(),
        companyId: document.companyId,
      };

      const { data, error } = await settleDocumentAndPoint({ input });

      if (!error) {
        dispatch(setUpdateDocuments({ value: true }));
        
        return dispatch(importAlertState({
          content: t("alerts.documentSettled"),
          state: "success",
          duration: 4,
        }));
      } else {
        const errorMessage = error?.graphQLErrors?.[0]?.message || error?.message || t("alerts.settleError");
        const isPeriodLocked = isPeriodClosedError(errorMessage);
        return dispatch(importAlertState({
          concept: isPeriodLocked ? t("common.periodClosed") : undefined,
          content: errorMessage,
          state: isPeriodLocked ? "warning" : "error",
          duration: isPeriodLocked ? 6 : 4,
        }));
      }

    } catch (err) {
      return dispatch(importAlertState({
        content: t("alerts.settleError"),
        state: "error",
        duration: 4,
      }));
    }
  };

  const settlePartialDocument = async (document, amount, paymentDate) => {
    try {
      setShowPartialPayoffModal(false);
      
      dispatch(
        importAlertState({
          content: `Saldando documento...`,
          state: "loading",
          duration: 100,
        })
      );

      const input = [{
        id: document._id,
        amount: parseFloat(amount),
        date: paymentDate ? new Date(paymentDate) : new Date(),
      }];

      const { data, error } = await settleDocumentMutation({ 
        companyId: document.companyId, 
        input 
      });

      if (!error && data?.settleDocument?.ok) {
        dispatch(setUpdateDocuments({ value: true }));
        
        return dispatch(importAlertState({
          content: t("alerts.documentSettled"),
          state: "success",
          duration: 4,
        }));
      } else {
        const errorMessage = error?.graphQLErrors?.[0]?.message || error?.message || t("alerts.settleError");
        const isPeriodLocked = isPeriodClosedError(errorMessage);
        return dispatch(importAlertState({
          concept: isPeriodLocked ? t("common.periodClosed") : undefined,
          content: errorMessage,
          state: isPeriodLocked ? "warning" : "error",
          duration: isPeriodLocked ? 6 : 4,
        }));
      }

    } catch (err) {
      return dispatch(importAlertState({
        content: t("alerts.settleError"),
        state: "error",
        duration: 4,
      }));
    }
  };

  const openModal = async (document) => {
    const pairs = inMatchPairsFromDocument(document);
    const blocked = await findBlockedSummary(pairs);
    if (blocked) {
      setStatementUnmatchSummary(blocked);
      return;
    }
    let bankTransactions = [];
    for (const pair of pairs) {
      const preflight = await fetchSummaryForPair(pair.originId, pair.endId);
      if (preflight?.blocked === false && Array.isArray(preflight.bankTransactions)) {
        bankTransactions = preflight.bankTransactions;
        break;
      }
    }
    const isBH = [0, 1, "0", 1].includes(document.meta?.documentCode);
    const subsubcontent = (
      <>
        <p>{t("alerts.matchedBalanceWarning")}</p>
        {bankTransactions.length > 0 ? (
          <>
            <p>{t("reconcile.statementLinkedUnmatchBankWarning")}</p>
            <ul>
              {bankTransactions.map((tx) => {
                const date = tx.date && moment(tx.date).isValid()
                  ? moment(tx.date).format("DD/MM/YYYY")
                  : "";
                const description = String(tx.description || "").trim();
                return (
                  <li key={tx.id}>
                    {[date, description].filter(Boolean).join(" — ") || tx.id}
                  </li>
                );
              })}
            </ul>
          </>
        ) : null}
      </>
    );
    const subcontent = `El nuevo saldo del documento será de ${formatMoneyWithCurrency(
      isBH ? document.meta.netAmount : document.amount
    )}.`;

    dispatch(
      importNewModal({
        show: true,
        title: t("modals.unsettle.title"),
        content:
          t("modals.unsettle.body"),
        subcontent,
        subsubcontent,
        onConfirmText: t("common.yesContinue"),
        onConfirm: async () => {
          await unSettleDocument(document);
        },
        children: <div></div>,
      })
    );
  };

  const docMatchTable = () => {
    dispatch(
      importOpenSidebar({
        show: true,
        reconcile: true,
        editData: data,
        options: { type: "documents", seeMatchs: true, activeIndex: 1, documentType: [data.documentType] },
        setTotal: setTotal
      })
    );
  };

  const editObligation = () => {
    dispatch(
      importOpenSidebar({
        show: true,
        editObligation: true,
        editData: data,
        source: "editObligation",
      })
    );
  };

  const createObligationSideBar = (data, type) => {
    if (type != null && type !== "" && isAbonarBlocked()) return;
    if ((type == null || type === "") && isCrearObligacionBlocked()) return;
    dispatch(
      importOpenSidebar({
        show: true,
        createObligation: true,
        editData: data,
        source: "documents",
        type,
      })
    );
  };

  const openReconcileSideBar = (e) => {
    // Prevent any default behavior that might cause scrolling
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    // Save current scroll position
    const currentScrollY = window.scrollY || window.pageYOffset;
    
    // Update URL with documentId and remove isComment parameter
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('documentId', data._id);
    newSearchParams.delete('isComment');
    newSearchParams.delete('isDocumentDetail');
    history.push({
      pathname: location.pathname,
      search: newSearchParams.toString()
    });

    // Use onOpenReconcile callback if provided (for inner sidebar), otherwise use Redux sidebar
    if (onOpenReconcile) {
      onOpenReconcile(data);
    }

    // Restore scroll position after dispatch (next tick)
    requestAnimationFrame(() => {
      window.scrollTo(0, currentScrollY);
    });
  };

  const openVincularModal = () => {
    setOpenCustomModal(true);
  }

  const openPartialPayoffModal = () => {
    setShowPartialPayoffModal(true);
    setPartialPayoffAmount(String(data.meta?.remaining ?? 0));
    setPartialPayoffDate(moment().format('YYYY-MM-DD'));
  }

  const isAmountBigger = parseFloat(partialPayoffAmount || 0) > (data.meta?.remaining || 0);

  // Normalize user input like "8.911.848" → "8911848" (CLP) or keep one decimal separator for non-CLP
  const normalizeAmountInput = (raw) => {
    const currency = data?.currencyType === 'CLP' ? 'CLP' : 'USD';
    let s = String(raw || '').replace(/\s/g, '');
    if (currency === 'CLP') {
      // CLP without decimals: keep only digits
      s = s.replace(/[^0-9]/g, '');
    } else {
      // Replace comma with dot and allow a single decimal point
      s = s.replace(/,/g, '.').replace(/[^0-9.]/g, '');
      const firstDot = s.indexOf('.');
      if (firstDot !== -1) {
        const before = s.slice(0, firstDot + 1);
        const after = s.slice(firstDot + 1).replace(/\./g, '');
        s = before + after;
      }
    }
    return s;
  };
 
  const isSelected = data._id === selectedDocumentId;
  const rowBaseBackground = isSelected ? "#EFF7F5" : data.isReported ? "#FEF2F2" : "#FFFFFF";
  const rowBackgroundColor = !isSelected && !data.isReported && isRowHovered ? "#FAFBFB" : rowBaseBackground;
  
  // Build description using getDescription helper
  const metaDescription = getDescription(data);
  const name = isCredit
    ? (data?.name || '')
    : (isReceived ? data?.meta?.issuerName || '' : data?.meta?.receiverName || '');
  const rut = isCredit
    ? ''
    : (isReceived
      ? (data?.meta?.issuerId ? formatRut(data.meta.issuerId) : '')
      : (data?.meta?.receiverId ? formatRut(data.meta.receiverId) : ''));
  const creditIdent = isCredit ? (data?.meta?.identificator || '') : '';
  const description = isCredit
    ? `${name}${creditIdent ? ' :: ' + creditIdent : ''}${metaDescription ? ' :: ' + metaDescription : ''}`.trim()
    : `${name} ${rut}${metaDescription ? ' :: ' + metaDescription : ''}`.trim();

  // Comments count:
  // - For most documents, comments live in `meta.innerComments`.
  // - For CREDIT documents, comments can also exist at match-level (`meta.matchs.*.innerComments`).
  const commentsCount = (() => {
    const direct =
      (data?.innerComments?.length || 0) +
      (data?.meta?.innerComments?.length || 0);

    if (!isCreditRoute) return direct;

    const inMatchComments = (data?.meta?.matchs?.inMatch || []).reduce(
      (acc, m) => acc + (m?.innerComments?.length || 0),
      0,
    );
    const outMatchComments = (data?.meta?.matchs?.outMatch || []).reduce(
      (acc, m) => acc + (m?.innerComments?.length || 0),
      0,
    );

    return direct + inMatchComments + outMatchComments;
  })();
  
  // Helper function to get document indicators (C, R, N)
  const getDocumentIndicators = (data) => {
    const indicators = [];
    
    // Check for factoring (Cedido) - Blue "C"
    const isFactoring = data.meta?.factoring?.cedido || 
      data.meta?.matchs?.inMatch?.some(match => match?.obligationType === 'factoring');
    
    if (isFactoring) {
      indicators.push({
        letter: 'C',
        color: '#0099ff', // Blue for factoring
        tooltip: t('tooltipsRow.factoring')
      });
    }

    // Boleta de honorarios / terceros anulada (misma semántica que FeesDetail + AnnulmentNotice)
    const isBoletaHonorarios = [0, 1, '0', '1'].includes(data.meta?.documentCode);
    if (isBoletaHonorarios && data.meta?.isValid === false) {
      indicators.push({
        letter: 'A',
        color: '#991b1b',
        tooltip: t('tooltipsRow.annulledFee'),
      });
    }

    // Check for rechazado/reclamado (protested) - Red "R"
    if (data.meta?.isProtested) {
      indicators.push({
        letter: 'R',
        color: '#e74c3c', // Red for protested/claimed
        tooltip: t('tooltipsRow.claimed')
      });
    }
    
    // Check for "No incluir" - Dark grey "N"
    if (data.meta?.state === "NO_INCLUIR") {
      indicators.push({
        letter: 'N',
        color: '#34495e', // Dark grey for "No incluir"
        tooltip: t('tooltipsRow.noInclude')
      });
    }
    
    return indicators;
  };
  
  const documentIndicators = getDocumentIndicators(data);
  
  // Check if document is clickable (same logic as DocumentInfoBar)
  const documentTypeForHelper = data.documentType || data.meta?.documentType;
  const isClickable = data._id && [DocumentType.TAX_DOCUMENT, DocumentType.OBLIGATION, DocumentType.CREDIT].includes(documentTypeForHelper);
  
  // Handler to open document detail modal
  const handleDocumentClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isClickable) {
      openDocumentDetail(data._id || data.id, history, location);
    }
  };

  const handleRowClick = (e) => {
    openReconcileSideBar(e);
  };

  const handleRowKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleRowClick(e);
    }
  };

  const isBhRetentionRow =
    location.pathname === "/boletas" &&
    data?.documentType === DocumentType.OBLIGATION;

  return (
    <>
      {/* Desktop Layout (1024px+) - Show compact version when reconcile panel is open */}
      {isReconcileOpen ? (
        <div className={`tw-w-full tw-hidden lg:tw-flex tw-py-3 tw-px-4 tw-border-solid tw-border-[1px] tw-rounded-md tw-shadow-sm tw-mt-2 tw-gap-4 ${
          data.isReported 
            ? 'tw-border-red-400' 
            : 'tw-border-[#e3eef2]'
        }`}
          onClick={handleRowClick}
          role="button"
          tabIndex={0}
          onKeyDown={handleRowKeyDown}
          onMouseEnter={() => setIsRowHovered(true)}
          onMouseLeave={() => setIsRowHovered(false)}
          style={{ backgroundColor: rowBackgroundColor }}
        >
          {/* Checkbox Column */}
          <div className="tw-flex tw-items-center tw-flex-shrink-0 tw-mr-2">
            <Checkbox
              checked={isAllSelected ? true : selectedDocs.includes(data._id)}
              onClick={(e, props) => {
                e.stopPropagation();
                if (props.checked) {
                  setSelectedDocs((old) => [...old, data._id]);
                  setSelectedAmountDocs((old) => [...old, data]);
                } else {
                  const newSelected = selectedDocs.filter((id) => id !== data._id);
                  const newSelectedAmountDocs = selectedAmountDocs.filter(
                    (amount) => amount._id !== data._id
                  );
                  setSelectedDocs(newSelected);
                  setSelectedAmountDocs(newSelectedAmountDocs);
                }
              }}
              className="tw-cursor-pointer"
            />
          </div>
          
          {/* Content Column - 3 Rows */}
          <div className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
            {/* Row 1: Amount, Date, Actions */}
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-mb-2">
              <div className="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0">
                {/* Summary/TypeLabel before arrow - clickable if document is clickable - matches documentInfoBar style */}
                <span 
                  className={`tw-font-bold tw-underline tw-whitespace-nowrap tw-flex-shrink-0 ${
                    isClickable ? 'tw-cursor-pointer hover:tw-underline' : ''
                  }`}
                  style={{ 
                    fontSize: '1rem',
                    color: isClickable ? '#176f80' : '#1f2d3a'
                  }}
                  onClick={isClickable ? handleDocumentClick : undefined}
                >
                  {(() => {
                    if (isCredit) {
                      const ident = data?.meta?.identificator;
                      const payNum = data?.meta?.paymentNumber;
                      const total = data?.meta?.totalPayments;
                      const cuota = (payNum && total) ? `Cuota ${payNum}/${total}` : (payNum ? `Cuota ${payNum}` : '');
                      return `${data?.name || t('common.credit')}${ident ? ' #' + ident : ''}${cuota ? ' · ' + cuota : ''}`.trim();
                    }
                    const summaryOrTypeLabel = getDocumentTypeDisplayLabel(data);
                    const documentId = data.meta?.documentId || data.meta?.number;
                    return documentId ? `${summaryOrTypeLabel} #${documentId}` : summaryOrTypeLabel;
                  })()}
                </span>
                {/* Amount - In or Out - matches documentInfoBar logic */}
                <div className={`tw-text-sm tw-font-semibold tw-whitespace-nowrap tw-flex-shrink-0 ${
                  isCredit ? 'tw-text-gray-800' : (isReceived ? 'tw-text-red-600' : 'tw-text-green-600')
                }`}>
                  {isCredit ? '' : (isReceived ? '↓ ' : '↑ ')}
                  {formatMoneyWithCurrency(Math.abs(amount), data.currencyType || 'CLP')}
                </div>

                {/* Interest / Stock for credits */}
                {isCreditRoute && (
                  <>
                    <div className="tw-text-xs tw-text-gray-700 tw-whitespace-nowrap tw-flex-shrink-0">
                      Int: {formatMoneyWithCurrency(Math.abs(interestAmount), data.currencyType || 'CLP')}
                    </div>
                    <div className="tw-text-xs tw-text-gray-700 tw-whitespace-nowrap tw-flex-shrink-0">
                      Cap: {formatMoneyWithCurrency(Math.abs(stockAmount), data.currencyType || 'CLP')}
                    </div>
                  </>
                )}
                
                {/* Date */}
                <div className="tw-text-xs tw-text-gray-600 tw-whitespace-nowrap tw-flex-shrink-0">
                  <TableDateCell value={data.documentDate} format="DD/MM/YY" />
                </div>
                <div className="tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0">
                  {documentIndicators.map((indicator, idx) => (
                    <CircleIndicator
                      key={idx}
                      letter={indicator.letter}
                      color={indicator.color}
                      tooltip={indicator.tooltip}
                      size={16}
                    />
                  ))}
                </div>
              </div>
              
              {/* Actions */}
              <div className="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0">
                {/* Comments Badge */}
                <div onClick={(e) => e.stopPropagation()}>
                  <CommentBadge
                    commentCount={commentsCount}
                    onClick={onClickNotesLabel}
                    size="small"
                  />
                </div>

                {/* Accounting Badge */}
                {showAccounting(roles, selectedCompany) && (
                  <div onClick={(e) => e.stopPropagation()}>
                    <AccountingBadge
                      entries={data?.entries}
                      entryStatus={data?.entryStatus}
                      matchAccounting={matchAccounting}
                      documentType={data?.documentType}
                      remaining={data?.meta?.remaining}
                      onClick={onClickAccountingLabel}
                      size="small"
                    />
                  </div>
                )}

              </div>
            </div>
            
            {/* Row 2: Description */}
            <div className="tw-mb-1">
              <div className="tw-text-sm tw-text-gray-900 tw-truncate tw-w-full">
                {description || t('common.noDescription')}
              </div>
              {data.meta?.comments && (
                <div className="tw-text-xs tw-text-gray-600 tw-truncate tw-w-full tw-mt-1">
                  {data.meta.comments}
                </div>
              )}
            </div>
            
            {/* Row 3: Progress Bar */}
            <div className="tw-min-h-[36px] tw-flex tw-flex-col tw-justify-center">
              {isUncollectible ? (
                <div className="tw-text-right">
                  <span className="scfo-incobrable-badge">× {t('reconcile.uncollectible')}</span>
                </div>
              ) : remaining === 0 ? (
                <div className="tw-text-right">
                  <span className="scfo-conciliado-badge">✓ {t('reconcile.reconciled')}</span>
                </div>
              ) : (
                <>
                  <p className="tw-text-xs tw-mb-1 tw-text-gray-600 tw-text-right tw-whitespace-nowrap">
                    {`${formatMoneyWithCurrency(Math.abs(remaining), data.currencyType || 'CLP')} restante`}
                  </p>
                  <Progress
                    className={progressTierClassName(reconciliationPct)}
                    value={Math.abs(amount) - Math.abs(remaining)}
                    total={Math.abs(amount)}
                    style={{ height: '6px', width: '100%', margin: 0 }}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div 
          className={`tw-w-full tw-hidden lg:tw-flex tw-py-2 tw-border-solid tw-border-[1px] tw-rounded-md tw-shadow-md tw-mt-2 ${
            data.isReported 
              ? 'tw-border-red-400' 
              : 'tw-border-[#e3eef2]'
          }`}
          onClick={handleRowClick}
          role="button"
          tabIndex={0}
          onKeyDown={handleRowKeyDown}
          onMouseEnter={() => setIsRowHovered(true)}
          onMouseLeave={() => setIsRowHovered(false)}
          style={{ backgroundColor: rowBackgroundColor }}
        >
        <div className="tw-w-full tw-flex tw-py-1 tw-items-center">
          {/* Left Section: Checkbox and Document Info */}
          <div className="tw-flex tw-items-center tw-px-4 tw-flex-1 tw-min-w-0 tw-gap-8">
            {/* Checkbox */}
            <div className="tw-w-[40px] tw-flex tw-justify-center tw-items-center tw-flex-shrink-0">
              <Checkbox
                checked={isAllSelected ? true : selectedDocs.includes(data._id)}
                onClick={(e, props) => {
                  e.stopPropagation();
                  if (props.checked) {
                    setSelectedDocs((old) => [...old, data._id]);
                    setSelectedAmountDocs((old) => [...old, data]);
                  } else {
                    const newSelected = selectedDocs.filter((id) => id !== data._id);
                    const newSelectedAmountDocs = selectedAmountDocs.filter(
                      (amount) => amount._id !== data._id
                    );
                    setSelectedDocs(newSelected);
                    setSelectedAmountDocs(newSelectedAmountDocs);
                  }
                }}
              />
            </div>
            
            {isCreditRoute ? (
              <div
                className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
                style={{ gridTemplateColumns }}
              >
                {/* Emisión */}
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    <TableDateCell value={data.documentDate} format="DD/MM/YYYY" />
                  </div>
                </div>
                {/* Nombre */}
                <div className="tw-px-3 tw-min-w-0">
                  <div className="tw-flex tw-items-center tw-gap-1 tw-min-w-0">
                    <div className="text-truncate text-left tw-text-xs lg:tw-text-sm tw-overflow-hidden tw-flex-1 tw-min-w-0">
                      {data?.name || "-"}
                    </div>
                    {documentIndicators.map((indicator, idx) => (
                      <CircleIndicator
                        key={idx}
                        letter={indicator.letter}
                        color={indicator.color}
                        tooltip={indicator.tooltip}
                        size={16}
                      />
                    ))}
                  </div>
                </div>
                {/* Identificador */}
                <div className="tw-px-3 tw-min-w-0">
                  <div className="text-truncate tw-text-xs lg:tw-text-sm tw-overflow-hidden">
                    {data?.meta?.identificator || "-"}
                  </div>
                </div>
                {/* Cuota */}
                <div className="tw-px-3">
                  <div className="text-truncate tw-text-xs lg:tw-text-sm">
                    {data?.meta?.paymentNumber
                      ? `${data.meta.paymentNumber}${data?.meta?.totalPayments ? '/' + data.meta.totalPayments : ''}`
                      : "-"}
                  </div>
                </div>
                {/* Capital (Stock) */}
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    {formatMoneyWithCurrency(Math.abs(stockAmount), data.currencyType || 'CLP')}
                  </div>
                </div>
                {/* Interés */}
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    {formatMoneyWithCurrency(Math.abs(interestAmount), data.currencyType || 'CLP')}
                  </div>
                </div>
                {/* Cuota (monto) */}
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    {formatMoneyWithCurrency(Math.abs(amount), data.currencyType || 'CLP')}
                  </div>
                </div>
                {/* Fecha Pago */}
                <div className="tw-px-3 tw-min-w-0">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm tw-overflow-hidden">
                    {data?.meta?.paymentDate && data.meta.paymentDate !== "-"
                      ? (
                        <TableDateCell
                          value={String(data.meta.paymentDate).substr(0, 10)}
                          format="DD/MM/YYYY"
                        />
                      )
                      : null}
                  </div>
                </div>
              </div>
            ) : isDinRoute ? (
              <div
                className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
                style={{ gridTemplateColumns }}
              >
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    <TableDateCell value={getDinIssuedDate(data)} format="DD/MM/YYYY" />
                  </div>
                </div>
                <div className="tw-px-3 tw-min-w-0">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm tw-overflow-hidden">
                    {getDinPaymentDate(data) ? (
                      <TableDateCell value={getDinPaymentDate(data)} format="DD/MM/YYYY" />
                    ) : (
                      <span className="scfo-table-date-placeholder">—</span>
                    )}
                  </div>
                </div>
                <div className="tw-px-3">
                  <div className="text-truncate docTableDocIdData tw-text-xs lg:tw-text-sm">
                    <span className="docTableDocIdLinkWrap" style={{ position: 'relative', zIndex: 10, pointerEvents: 'auto' }}>
                      <a href="javascript:;" onClick={docDetailTable} className="docTableDocIdLink">
                        {data.meta.documentId || data.meta.din?.documentId || t("common.view")}
                      </a>
                      <span className="docTableDocIdHoverHint">
                        <i className="arrow up right icon docTableDocIdHoverIcon" />
                      </span>
                    </span>
                  </div>
                </div>
                <div className="tw-px-3">
                  <div className="text-truncate tw-text-xs lg:tw-text-sm">
                    {getDinForm(data)}
                  </div>
                </div>
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    {formatMoneyWithCurrency(getDinNetAmount(data), "CLP")}
                  </div>
                </div>
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    {formatMoneyWithCurrency(getDinTaxAmount(data), "CLP")}
                  </div>
                </div>
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    {formatMoneyWithCurrency(getDinOriginalAmount(data), "CLP")}
                  </div>
                </div>
              </div>
            ) : location.pathname === "/boletas" ? (
              <div
                className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
                style={{ gridTemplateColumns }}
              >
                {/* Emision */}
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    <TableDateCell value={data.documentDate} format="DD/MM/YYYY" />
                  </div>
                </div>
                {/* Razon Social */}
                <div className="tw-px-3 tw-min-w-0">
                  <div className="tw-flex tw-items-center tw-gap-1 tw-min-w-0">
                    <div className="text-truncate text-left docTableNameData tw-text-xs lg:tw-text-sm tw-overflow-hidden tw-flex-1 tw-min-w-0">
                      {isReceived
                        ? data.meta.issuerName || t("common.noCounterparty")
                        : data.meta.receiverName || t("common.noCounterparty")}
                    </div>
                    {isBhRetentionRow && (
                      <span className="tw-inline-flex tw-items-center tw-px-1.5 tw-py-0.5 tw-rounded tw-bg-gray-100 tw-text-[11px] tw-font-medium tw-text-gray-600 tw-flex-shrink-0 tw-normal-case">
                        {t("table.retentionRow.label")}
                      </span>
                    )}
                    {documentIndicators.map((indicator, idx) => (
                      <CircleIndicator
                        key={idx}
                        letter={indicator.letter}
                        color={indicator.color}
                        tooltip={indicator.tooltip}
                        size={16}
                      />
                    ))}
                  </div>
                </div>
                {/* Rut */}
                <div className="tw-px-3">
                  <div className="text-truncate docTableRutData tw-text-xs lg:tw-text-sm">
                    {formatRut(isReceived ? data.meta.issuerId : data.meta.receiverId) || "-"}
                  </div>
                </div>
                {/* Folio */}
                <div className="tw-px-3">
                  <div className="text-truncate docTableDocIdData tw-text-xs lg:tw-text-sm">
                    <span className="docTableDocIdLinkWrap" style={{ position: 'relative', zIndex: 10, pointerEvents: 'auto' }}>
                      <a href="javascript:;" onClick={docDetailTable} className="docTableDocIdLink">
                        {data.meta.documentId || data.meta.number || t("common.view")}
                      </a>
                      <span className="docTableDocIdHoverHint">
                        <i className="arrow up right icon docTableDocIdHoverIcon" />
                      </span>
                    </span>
                  </div>
                </div>
                {/* Monto Neto */}
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    {isBhRetentionRow ? (
                      <span className="scfo-table-date-placeholder">—</span>
                    ) : (
                      formatMoneyWithCurrency(
                        resolveTableMontoAmount(data),
                        data.currencyType || 'CLP',
                      )
                    )}
                  </div>
                </div>
                {/* Retención */}
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    {formatMoneyWithCurrency(
                      isBhRetentionRow ? (data.amount || 0) : (data.meta?.taxAmount || 0),
                      data.currencyType || 'CLP'
                    )}
                  </div>
                </div>
                {/* Fecha Pago */}
                <div className="tw-px-3 tw-min-w-0">
                  <div
                    className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm tw-overflow-hidden"
                  >
                    {data.paymentDate && data.paymentDate !== "-"
                      ? (
                        <TableDateCell
                          value={data.paymentDate.substr(0, 10)}
                          format="DD/MM/YYYY"
                        />
                      )
                      : null}
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="tw-grid tw-items-center tw-flex-1 tw-min-w-0 tw-gap-x-2"
                style={{ gridTemplateColumns }}
              >
                {/* Emision */}
                <div className="tw-px-3">
                  <div className="text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                    <TableDateCell value={data.documentDate} format="DD/MM/YYYY" />
                  </div>
                </div>
                {/* Razon Social */}
                <div className="tw-px-3 tw-min-w-0">
                  <div className="text-truncate text-left docTableNameData tw-text-xs lg:tw-text-sm tw-overflow-hidden">
                    {isReceived
                      ? data.meta.issuerName || "SIN CONTRAPARTE"
                      : data.meta.receiverName || "SIN CONTRAPARTE"}
                  </div>
                </div>
                {/* Rut */}
                <div className="tw-px-3">
                  <div className="text-truncate docTableRutData tw-text-xs lg:tw-text-sm">
                    {formatRut(isReceived ? data.meta.issuerId : data.meta.receiverId) || "-"}
                  </div>
                </div>
                {/* Tipo */}
                <div className="tw-px-3 tw-min-w-0 tw-flex tw-items-center tw-gap-2 tw-flex-wrap">
                  <div className="text-truncate docTableDocTypeData tw-text-xs lg:tw-text-sm tw-overflow-hidden tw-flex-1 tw-min-w-0">
                    {getDocumentTypeDisplayLabel(data)}
                  </div>
                  <div className="tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0">
                    {documentIndicators.map((indicator, idx) => (
                      <CircleIndicator
                        key={idx}
                        letter={indicator.letter}
                        color={indicator.color}
                        tooltip={indicator.tooltip}
                        size={16}
                      />
                    ))}
                  </div>
                  <Popup
                    content={t('sii.pendingApprove')}
                    inverted
                    trigger={
                      <Icon
                        name="exclamation circle"
                        color="blue"
                        className="tableRowDocumentState"
                        onClick={(e) => {
                          e.stopPropagation();
                          acceptDocSidebar(data);
                        }}
                        hidden={!(data.meta?.state == DOCUMENT_STATE.PENDIENTE)} />
                    }
                  />
                </div>
                {/* Folio */}
                <div className="tw-px-3 tw-text-xs lg:tw-text-sm">
                  <span className="docTableDocIdLinkWrap text-truncate docTableDocIdData tw-block" style={{ position: 'relative', zIndex: 10, pointerEvents: 'auto' }}>
                    <a href="javascript:;" onClick={docDetailTable} className="docTableDocIdLink">
                      {data.meta.documentId || data.meta.number || t("common.view")}
                    </a>
                    <span className="docTableDocIdHoverHint">
                      <i className="arrow up right icon docTableDocIdHoverIcon" />
                    </span>
                  </span>
                </div>
                {/* Monto */}
                <div className="tw-px-3 tw-text-uppercase text-truncate tw-text-xs lg:tw-text-sm">
                  {formatMoneyWithCurrency(
                    resolveTableMontoAmount(data),
                    data.currencyType || 'CLP',
                  )}
                </div>
                {/* Fecha Pago */}
                <div className="tw-px-3 tw-min-w-0">
                  <div className="tw-text-uppercase text-truncate tw-text-xs lg:tw-text-sm tw-overflow-hidden">
                    {data.paymentDate && data.paymentDate !== "-"
                      ? (
                        <TableDateCell
                          value={data.paymentDate.substr(0, 10)}
                          format="DD/MM/YYYY"
                        />
                      )
                      : null}
                  </div>
                </div>
              </div>
            )}

          </div>

          {/* Right Section: Comment Icon, Progress Bar, and Button */}
          {!small && (
            <div className="tw-flex tw-flex-nowrap tw-items-center tw-px-3 tw-flex-shrink-0 tw-gap-4 tw-justify-end tw-ml-auto">
              {/* Conflict Warning (fixed slot to preserve alignment) */}
              <div className="tw-w-8 tw-flex tw-justify-center tw-items-center tw-flex-shrink-0">
                {showConflict ? (
                  <div className="settleConflict">
                    <Popup
                      inverted
                      position='top center'
                      content={t('conflict.partialPayNomina')}
                      trigger={
                        <Icon
                          className="cursor-pointer"
                          name='exclamation triangle'
                          color='orange'
                          size='large'
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowModal(true)
                          }}
                        />
                      }
                    />
                  </div>
                ) : null}
              </div>

              {/* Comments Badge - fixed width */}
              <div
                className="tw-w-8 tw-flex-shrink-0 tw-flex tw-justify-center tw-items-center"
                onClick={(e) => e.stopPropagation()}
              >
                <CommentBadge 
                  commentCount={commentsCount}
                  onClick={onClickNotesLabel}
                />
              </div>

                {/* Accounting Badge — no overflow:hidden: badge overlaps top/right of icon (AccountingBadge uses negative top/right) */}
              <div
                className="tw-w-8 tw-flex-shrink-0 tw-flex tw-justify-center tw-items-center tw-min-h-[22px]"
                onClick={(e) => e.stopPropagation()}
              >
                {showAccounting(roles, selectedCompany) && (
                  <AccountingBadge
                    entries={data?.entries}
                    entryStatus={data?.entryStatus}
                    matchAccounting={matchAccounting}
                    documentType={data?.documentType}
                    remaining={data?.meta?.remaining}
                    onClick={onClickAccountingLabel}
                  />
                )}
              </div>
              
              {/* Progress Bar (fixed width, non-shrinking) */}
              <div
                className="tw-flex-shrink-0 tw-flex tw-justify-center tw-items-stretch tw-flex-col tw-min-h-[36px]"
                style={{
                  width: progressColWidthPx,
                  minWidth: progressColWidthPx,
                  maxWidth: progressColWidthPx,
                }}
              >
                {isUncollectible ? (
                  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-min-h-[36px]">
                    <span className="scfo-incobrable-badge">× {t('reconcile.uncollectible')}</span>
                  </div>
                ) : remaining === 0 ? (
                  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-min-h-[36px]">
                    <span className="scfo-conciliado-badge">✓ {t('reconcile.reconciled')}</span>
                  </div>
                ) : (
                  <>
                    <Progress
                      className={progressTierClassName(reconciliationPct)}
                      value={Math.abs(amount) - Math.abs(remaining)}
                      total={Math.abs(amount)}
                      style={{
                        height: '13px',
                        width: progressColWidthPx,
                        minWidth: progressColWidthPx,
                        maxWidth: progressColWidthPx,
                      }}
                    />
                    <p className="tw-text-xs tw-leading-tight tw-mt-1 tw-text-gray-700 tw-whitespace-nowrap tw-text-center tw-w-full">
                      {`${formatMoneyWithCurrency(Math.abs(remaining), data.currencyType || 'CLP')} ${t('common.remainingSuffix')}`}
                    </p>
                  </>
                )}
              </div>
              
            </div>
          )}
                {/* {(!plan.includes(Plans.smartcfo)) ?
                  <div className="ml-2 transactionState">
                    <Popup
                      trigger={
                        <Icon
                          name={
                            (data?.fieldKey == 'none' ? "ban" : data?.fieldKey &&
                              eerrMacroCategories.macroCategories.find(
                                (f) =>
                                  f.category ==
                                  (eerrAreas[data?.fieldKey]
                                    ? eerrAreas[data?.fieldKey].macroCategoryKey
                                    : null)
                              )?.icon) ||
                            null
                          }
                          color={
                            data?.fieldKey == 'none'
                              ? "grey"
                              : eerrMacroCategories.macroCategories.find(
                                (f) =>
                                  f.category ==
                                  (eerrAreas[data?.fieldKey]
                                    ? eerrAreas[data?.fieldKey].macroCategoryKey
                                    : null)
                              )?.color || 'grey'
                          }
                          onClick={() => openReconcileSideBar()}
                        />
                      }
                      content={
                        data?.fieldKey == 'none' ? "Sin clasificar " :
                          eerrAreas[data?.fieldKey]
                            ? eerrAreas[data?.fieldKey].name
                            : "Clasificar"
                      }
                      inverted
                      position="top center"
                    />
                  </div> : <></>
                } */}
        </div>
      </div>
      )}

      <VincularDocumentoModal
        open={openCustomModal}
        onClose={() => setOpenCustomModal(false)}
        data={data}
      />
      
      <ModalSettleConflictNominas
        show={showModal}
        setShowModal={setShowModal}
        data={data}
        showConflict={showConflict}
        setShowConflict={setShowConflict}
      />

      {showPartialPayoffModal && (
        <CustomModal
          onClose={() => setShowPartialPayoffModal(false)}
          open={showPartialPayoffModal}
          size='tiny'
          dimmer="blurring"
          title={t("modals.settle.titleLower")}
          confirmLabel={t("modals.settle.confirm")}
          onConfirm={() => settlePartialDocument(data, partialPayoffAmount, partialPayoffDate)}
          confirmDisabled={isAmountBigger || !partialPayoffAmount || parseFloat(partialPayoffAmount) <= 0}
          content={
            <>
            <p>{t("modals.settle.partialConfirm")}</p>
            <br />
            <Form.Input
              label={t("modals.settle.amountToSettleLabel")}
              id="partialPayoffInput"
              type="text"
              inputMode="decimal"
              icon={{ name: "dollar", color: "grey" }}
              iconPosition='left'
              placeholder={t("modals.settle.amountPlaceholder")}
              value={partialPayoffAmount}
              onChange={(e) => setPartialPayoffAmount(normalizeAmountInput(e.target.value))}
              style={{ paddingLeft: "10px", width: "100%" }}
            />
            <div className="mt-3" hidden={!isAmountBigger}>
              <span className="text-danger">{`El nuevo monto debe tener un rango entre ${formatMoneyWithCurrency(0, data.currencyType || 'CLP')} y ${formatMoneyWithCurrency(data.meta?.remaining || 0, data.currencyType || 'CLP')}`}</span>
            </div>
            <Form.Input
              label={t("bulkSettle.paymentDateLabel")}
              type="date"
              placeholder={t("modals.settle.paymentDatePlaceholder")}
              name="date"
              value={partialPayoffDate}
              onChange={(_, v) => setPartialPayoffDate(v.value)}
              className="w-100 mt-4"
              style={{ paddingLeft: "10px" }}
              fluid
            />
            </>
          }
        />
      )}

      <CustomModal
        size="tiny"
        open={openType === "open"}
        onClose={() => setOpenType('close')}
        dimmer="blurring"
        title={t("modals.settle.title")}
        cancelarLabel={t("modals.settle.confirmNo")}
        confirmLabel={t("modals.settle.confirmYes")}
        onConfirm={() => settleDocument(data, total)}
        confirmVariant="success"
        content={
          <>
          <p>
            {`¿Estás seguro de querer saldar ${data.meta.summary || data.meta.typeLabel || 'este documento'
              }${data.meta.documentId || data.meta.number ? ' #' : ''}${data.meta?.documentId || data.meta.number
                ? data.meta.documentId || data.meta.number
                : ''
              } con monto por pagar de ${formatMoneyWithCurrency(
                data.meta?.remaining ?? data.amount
              )} y fecha de emisión ${formatSafeTableDate(data.documentDate, 'DD/MM/YYYY') ?? '—'}?`}
          </p>
          <Input
            fluid
            type="date"
            label={t("common.paymentDate")}
            onChange={(e, props) => setTotal(props.value)}
          />
          </>
        }
      />

      <StatementLinkedUnmatchModal
        open={Boolean(statementUnmatchSummary)}
        summary={statementUnmatchSummary}
        onClose={() => setStatementUnmatchSummary(null)}
      />
    </>
  );
};

export default TablaFila;